<template>
    <div :class="`product-style-one ${productStyleClass} w-full p-5 rounded-xl relative z-10`">
        <div class="card-thumbnail overflow-hidden rounded-md relative -mx-4">
            <img :src="productDate.image" :alt="productDate.productName" @load="$emit('handleImageLoad')" class="rounded-md object-cover w-full h-auto transition-transform duration-500 hover:scale-110">
            <countdown v-if="productDate.countdown" :date="productDate.countdown.date" />
            <router-link v-if="showPlaceBid" :to="`/product/${productDate.id}`" class="btn btn-primary absolute top-1/2 left-1/3 transform scale-0 transition-transform duration-300 rounded py-2 px-3 hover:text-white">
                Place Bid
            </router-link>
        </div>
        <div class="product-share-wrapper flex justify-between items-center mt-8">
        </div>
        <span class="product-name text-lg block mt-4">{{ productDate.title }}</span>
        <span class="latest-bid mt-3 block overflow-hidden" style="display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; line-height: 1.5; max-height: 3em;">{{ productDate.description }}</span>
        <div class="bid-react-area flex justify-between mt-4">
            <div class="react-area relative z-10 flex items-center transition-all cursor-pointer p-1 px-2 rounded-md text-white">
                <i class="fa fa-eye mr-1 relative w-4"></i>
                <span class="number text-sm relative">{{ productDate.views }}</span>
            </div>
            <div class="react-area relative z-10 flex items-center transition-all cursor-pointer p-1 px-2 rounded-md text-white">
                <i class="fa-info mr-1 relative w-4" />
                <span class="number text-sm relative">{{ productDate.comments }}</span>
            </div>
            <div class="react-area relative z-10 flex items-center transition-all cursor-pointer p-1 px-2 rounded-md text-white">
                <i class="feather-heart mr-1 relative w-4" />
                <span class="number text-sm relative">{{ productDate.likes }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import Countdown from '@/components/product/Countdown';

export default {
    name: 'ProductCard1',
    components: { Countdown },
    props: {
        productDate: {},
        productStyleClass: {
            type: String
        },
        showPlaceBid: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        '$route': function (to, from) {
            this.closeModal()
        }
    },
    methods: {
        closeModal() {
            const modals = document.querySelectorAll('.modal-backdrop');

            if (modals.length) {
                modals.forEach(item => {
                    item.remove();
                })
            }
        }
    }
}
</script>

<style scoped>
.product-style-one {
    background: var(--background-color-4);
}

.product-style-one::before {
    content: '';
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    border-radius: 15px;
    background-image: linear-gradient(100deg, #13131d, #0398ed);
    background-repeat: repeat-x;
    transition: all .5s;
    width: 99%;
    height: 100%;
    z-index: -2;
}

.product-style-one::after {
    content: "";
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: #242435;
    position: absolute;
    border-radius: 10px;
    z-index: -1;
}

.product-style-one:hover::before {
    transform: rotate(2deg) translateX(-7px) translateY(11px);
}

.card-thumbnail::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    background-image: linear-gradient(180deg, transparent, black);
    height: 50%;
    width: 100%;
    z-index: 1;
}

.react-area::after {
    background: var(--color-primary-alta);
    position: absolute;
    content: '';
    top: 0;
    z-index: -1;
    border-radius: 6px;
    transition: var(--transition);
    opacity: 0;
    width: 100%;
    left: 0;
    height: 100%;
}

.react-area:hover::after {
    opacity: 1;
    background: var(--color-primary);
}
</style>